import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.67",
      d: "M10 16.666h7.5m-3.75-13.75a1.768 1.768 0 0 1 2.5 2.5L5.833 15.833l-3.333.833.833-3.333z"
    }, null, -1)
  ])))
}
export default { render: render }